import { render, staticRenderFns } from "./Transferencias.vue?vue&type=template&id=7872cd2c"
import script from "./Transferencias.vue?vue&type=script&lang=js"
export * from "./Transferencias.vue?vue&type=script&lang=js"
import style0 from "./Transferencias.vue?vue&type=style&index=0&id=7872cd2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports